import { AccentButton } from "shared/components/buttons/AccentButton"
import styled from "styled-components"

export const CommerceFooter = styled.footer`
  background-color: ${(props) => props.theme.backgroundShade};
  width: 100%;
  padding: 10px 20px 10px 2px; // left padding is smaller because the back button appears smaller than it is
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  line-height: normal;
  height: ${(props) => props.theme.commerce.footerHeight};
  margin-top: auto;
  bottom: 0;
  left: 0;
  right: 0;

  ${AccentButton} {
    margin-left: auto;
  }
`
